// extracted by mini-css-extract-plugin
export var innerTrackDetails = "styles-module__innerTrackDetails___tDU4k";
export var trackContainer = "styles-module__trackContainer___yvq6u";
export var trackWaypointsContainer = "styles-module__trackWaypointsContainer___A5We2";